module.exports = __webpack_public_path__ + "static/media/MHRM09N1030.102960af.svg";